import { IS_SERVER } from "@/constants";
export const getCookieValue = (key, defaultValue = undefined) => {
    if (IS_SERVER)
        return defaultValue;
    const regex = new RegExp(`${key}=([^;]+)`);
    const match = regex.exec(document.cookie);
    return match ? match[1] : defaultValue;
};
